export const TOAST = {
  expenseLogged: 'Expense logged',
  expenseLoggedSplit: (amt) => `$${amt} split`,
  expenseUpdated: 'Expense updated',
  expenseArchived: 'Expense archived',
  categoryAdded: 'Category added',
  categoryUpdated: 'Category updated',
  categoryDeleted: 'Category deleted',
  defaultUpdated: 'Default preference saved',
  settlementLogged: 'Settlement logged',
  errorGeneric: 'Something went wrong',
  errorAmountRequired: 'Enter an amount first',
  errorCategoryName: 'Category name is required',
  errorCategoryNameMax: 'Category name must be 50 characters or less',
  errorDescriptionMax: 'Description must be 500 characters or less',
  errorMaxCustomCategories: 'Free users limited to 3 custom categories',
  errorPayerRequired: 'Select who paid',
  errorRatioTotal: 'Split percentages must total 100',
};

export const MOTION = {
  springEaseOut: { type: 'spring', damping: 25, stiffness: 300 },
  fadeDuration: 0.15,
  pageTransition: {
    initial: { opacity: 0, y: 8 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -8 },
    transition: { duration: 0.2 },
  },
};

export const LONG_PRESS_DURATION = 500;

export const MAX_LENGTHS = {
  description: 500,
  categoryName: 50,
  spaceName: 100,
};

export const SPLIT_OPTIONS = [
  { label: 'KEEP', value: 0 },
  { label: '50/50', value: 50 },
  { label: '60/40', value: 60 },
  { label: '70/30', value: 70 },
  { label: '80/20', value: 80 },
  { label: '90/10', value: 90 },
  { label: 'Custom', value: -1 },
];

export const CATEGORY_EMOJIS = [
  '🏠', '🛒', '🍕', '⚡', '📱', '🚗', '💧', '🎬', '🏋️', '📚',
  '🐾', '👶', '🎁', '💊', '🧹', '🌐', '📦', '🎓', '✈️', '👗',
  '🔧', '🏦', '💰', '🎮', '🍔', '☕', '🧾', '🏥', '🎵', '💡',
  '🅿️', '🧺', '⛽', '🛍️', '🚌', '🧴',
];

export const DEFAULT_SPACE_CATEGORIES = [
  { name: 'Groceries', emoji: '🛒', is_fixed: false, is_pinned: true, sort_order: 0 },
  { name: 'Rent', emoji: '🏠', is_fixed: true, is_pinned: true, sort_order: 1 },
  { name: 'Utilities', emoji: '💡', is_fixed: true, is_pinned: true, sort_order: 2 },
  { name: 'Dining Out', emoji: '🍽️', is_fixed: false, is_pinned: false, sort_order: 3 },
  { name: 'Transport', emoji: '🚗', is_fixed: false, is_pinned: false, sort_order: 4 },
];
